import React, { useState } from "react";
import Slider from "react-slick";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import "./Slider.css";
import { projectsmobileviewslider1, xs } from "../../../../assets";


// 👇 TypeScript fix
const SliderComponent = Slider as any;

/* =========================
   🖥️ DESKTOP IMAGES
========================= */
const desktopImages = [
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/Frame%20142.png" },
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/Frame%20143.png" },
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/Frame%20144.png" },
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/Frame%20145.png" },
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/Frame%20146.png" },
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/Frame%20147.png" },
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/Frame%20148.png" },
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/Frame%20149.png" },
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/Frame%20150.png" },

];

/* =========================
   📱 MOBILE IMAGES (NEW)
========================= */
const mobileImages = [
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/mobileslider1.png" },
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/mobileslider10.png" },
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/mobileslider3.png" },
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/mobileslider4.png" },
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/mobileslider6.png" },
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/mobileslider7.png" },
  { url: "https://dprstorage.b-cdn.net/RW/leadgen/mobileslider9.png" },

];

/* =========================
   🔁 GENERATOR
========================= */
const generateImages = (list: any[], count = 9) =>
  Array.from({ length: count }, (_, i) => list[i % list.length]);

const ProjectSlider: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [nav1, setNav1] = useState<any>(null);
  const [nav2, setNav2] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [animationIndex, setAnimationIndex] = useState(0);

  // 🔥 SWITCH IMAGES BASED ON DEVICE
  const selectedImages = isMobile ? mobileImages : desktopImages;
  const sliderImages = generateImages(selectedImages, 9);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
        height: {xs:"95vh",md:"100vh"},
      }}
    >
      {/* 🔥 MAIN SLIDER */}
      <SliderComponent
        asNavFor={nav2}
        ref={(slider: any) => setNav1(slider)}
        arrows={false}
        fade
        autoplay
        infinite
        speed={1000}
        autoplaySpeed={3000}
        pauseOnHover={true}
        cssEase="ease-in-out"
        beforeChange={(oldIndex: number, next: number) => {
          setActiveIndex(next);
          setAnimationIndex(next);
        }}
      >
        {sliderImages.map((item, index) => (
          <Box
            key={index}
            className={`slider-banner-image ${
              animationIndex === index ? "scale-anim" : ""
            }`}
            sx={{
              height: "100vh",
              width: "100%",
              overflow: "hidden",
            }}
          >
            <img
              src={item.url}
              alt={`slide-${index}`}
              loading="lazy"
              decoding="async"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        ))}
      </SliderComponent>

      {/* 🔥 THUMBNAILS (DESKTOP ONLY) */}
      {!isMobile && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            height: "100vh",
            width: 120,
            pt: 2,
          }}
        >
          <SliderComponent
            asNavFor={nav1}
            ref={(slider: any) => setNav2(slider)}
            slidesToShow={4}
            swipeToSlide
            focusOnSelect
            vertical
            verticalSwiping
            arrows={false}
          >
            {sliderImages.map((item, index) => (
              <Box
                key={index}
                className={`thumbnail-image ${
                  activeIndex === index ? "active" : ""
                }`}
                sx={{ px: 1 }}
              >
                <Box
                  className="thumbImg"
                  sx={{
                    height: "calc(100vh / 4)",
                    width: "100%",
                    border:
                      activeIndex === index
                        ? "2px solid #C6A15B"
                        : "1px solid #EBEBEB",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={item.url}
                    alt={`thumb-${index}`}
                    loading="lazy"
                    decoding="async"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      opacity: activeIndex === index ? 1 : 0.4,
                      transition: "0.3s",
                    }}
                  />
                </Box>
              </Box>
            ))}
          </SliderComponent>
        </Box>
      )}
    </Box>
  );
};

export default ProjectSlider;